export const invitationLetterTpl =
`
<p>一、名称：投标保证金电子保函。由绍兴市融资担保有限公司提供。</p>
<p>二、保函形式：电子保函。根据《中华人民共和国民法典》第四百六十九条规定，电子保函与纸质保函具有同等法律效力。</p>
<p>三、请您在申请前务必详细阅读《投标电子保函申请书》《投标电子保函开立、退费、代偿规则》《绍兴市融资担保电子保函服务平台操作手册》《投保须知》等内容。</p>
<p>四、保函开立人（担保人）根据相关费率标准综合确定，按照担保金额的0.4%收取担保费，低于500元的按500元收取。</p>
<p>五、投标电子系统确定开标后，您需在10个工作日内申请开票，延期申请或不主动申请开票，担保人有权利直接开具电子普票，且您不得要求更换发票开具的种类。</p>
<p>六、请您在申请前务必详细阅读以下文件，并认真对待：</p>
<p>（一）《绍兴市融资担保电子保函服务平台操作手册》，<a href="/api/insure/index/download?type=manual" target="_blank">附件下载</a>。</p>
<p>（二）《投标电子保函开立、退费、代偿规则》，<a href="/api/insure/index/download?type=rules" target="_blank">附件下载</a>。</p>
<p>七、请您于项目《招标文件》规定的“投标保证金缴纳截止时间”前完成担保费支付，否则申请无效，因您未及时缴纳保费导致无法参加投标或投标失效，由您自行承担相应后果。</p>
<p>八、发票申请操作详见《绍兴市融资担保电子保函服务平台操作手册》。</p>
<p>九、退保申请操作详见《投标电子保函开立、退费、代偿规则》的“二、退费规则”相应规定和《绍兴市融资担保电子保函服务平台操作手册》。</p>
<p>十、您方授权电子保函开立人，有权验证保费支付账户是否为对公基本账户，您不得因此向开立人主张任何形式的赔偿或其他法律责任。在保函项下全部义务和责任履行完毕之前，我司有权查询您的信用信息、工商信息等，您应积极配合并按我司要求出具相关资料。</p>
<p>十一、您需如实提供银行打款凭证、授权委托书、基本户信息、营业执照、法定代表人身份证、资质证书、安全生产许可证等资料，如弄虚作假自行承担责任。</p>
<p>我已知晓：我在申请投标电子保函过程中通过本系统阅读、点击的内容均可作为法律依据，保函开立人代偿后可凭此内容作为法律证据向我追偿。申请过程中我将仔细阅读相关内容，了解并知晓电子保函出具的法律后果，签字视为对我阅读的所有内容的确认。</p>
`

export const invitationLetterTpls =
`
<p>一、名称：投标保证金电子保函。由绍兴市融资担保有限公司提供。</p>
<p>二、保函形式：电子保函。根据《中华人民共和国民法典》第四百六十九条规定，电子保函与纸质保函具有同等法律效力。</p>
<p>三、请您在申请前务必详细阅读《投标电子保函申请书》《投标电子保函开立、退费、代偿规则》《绍兴市融资担保电子保函服务平台操作手册》《投保须知》等内容。</p>
<p>四、保函开立人（担保人）根据相关费率标准综合确定，按照担保金额的0.4%收取担保费，低于200元的按200元收取。</p>
<p>五、投标电子系统确定开标后，您需在10个工作日内申请开票，延期申请或不主动申请开票，担保人有权利直接开具电子普票，且您不得要求更换发票开具的种类。</p>
<p>六、请您在申请前务必详细阅读以下文件，并认真对待：</p>
<p>（一）《绍兴市融资担保电子保函服务平台操作手册》，<a href="/api/insure/index/download?type=manual" target="_blank">附件下载</a>。</p>
<p>（二）《投标电子保函开立、退费、代偿规则》，<a href="/api/insure/index/download?type=rules_shangYu" target="_blank">附件下载</a>。</p>
<p>七、请您于项目《招标文件》规定的“投标保证金缴纳截止时间”前完成担保费支付，否则申请无效，因您未及时缴纳保费导致无法参加投标或投标失效，由您自行承担相应后果。</p>
<p>八、发票申请操作详见《绍兴市融资担保电子保函服务平台操作手册》。</p>
<p>九、退保申请操作详见《投标电子保函开立、退费、代偿规则》的“二、退费规则”相应规定和《绍兴市融资担保电子保函服务平台操作手册》。</p>
<p>十、您方授权电子保函开立人，有权验证保费支付账户是否为对公基本账户，您不得因此向开立人主张任何形式的赔偿或其他法律责任。在保函项下全部义务和责任履行完毕之前，我司有权查询您的信用信息、工商信息等，您应积极配合并按我司要求出具相关资料。</p>
<p>十一、您需如实提供银行打款凭证、授权委托书、基本户信息、营业执照、法定代表人身份证、资质证书、安全生产许可证等资料，如弄虚作假自行承担责任。</p>
<p>我已知晓：我在申请投标电子保函过程中通过本系统阅读、点击的内容均可作为法律依据，保函开立人代偿后可凭此内容作为法律证据向我追偿。申请过程中我将仔细阅读相关内容，了解并知晓电子保函出具的法律后果，签字视为对我阅读的所有内容的确认。</p>
`


export default {invitationLetterTpl,invitationLetterTpls};
